module.exports = __webpack_public_path__ + "img/2.7fd6bba9.png";